export default __webpack_public_path__ + "static/media/growthOS.8197e0c3.svg";